import { Category } from 'apis/restaurant-api/merchant-admin/menu2/types';

import { flattenCategories } from '../utils';

type BulkActionBasePayload = {
  category_ids: string[];
  item_ids: string[];
};

export const buildBulkActionBasePayload = (categories: Category[], selectedIds: Set<string>): BulkActionBasePayload => {
  const allCategories = flattenCategories(categories);
  if (allCategories.length === 0) {
    return {
      category_ids: [],
      item_ids: [...selectedIds],
    };
  }

  const selectedItemIds = new Set([...selectedIds]);

  const categoryIdsWithAllItemsSelected = allCategories
    .filter(
      category =>
        category.item_bindings.length > 0 &&
        category.item_bindings.every(itemBinding => selectedIds.has(itemBinding.item_id)),
    )
    .map(category => {
      for (const itemBinding of category.item_bindings) {
        selectedItemIds.delete(itemBinding.item_id);
      }
      return category.id;
    });

  return {
    category_ids: categoryIdsWithAllItemsSelected,
    item_ids: [...selectedItemIds],
  };
};
